// Module
var code = "<div class=\"users-tab\"> <div class=\"col-xs-12\" data-bind=\"component: { name: 'dual-list-box', params: dualListBoxOptions }\"></div> </div>";
// Exports
export default code;